import get from "lodash/get";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import Modal from "../modal";
import DateInput from "../inputs/date-input";
const {
  DATE_FORMATS: { DATE_PICKER_FORMAT, DATE_DAY_FORMAT },
} = require("../../constants");

class ExportWorkoutModal extends React.Component {
  render() {
    const { locals } = this.context;
    const { query } = locals;

    const activeDay = moment.utc(query.day, DATE_DAY_FORMAT).startOf("day");
    const exportDate = moment
      .utc(get(query, "modal.date"), DATE_DAY_FORMAT)
      .format(DATE_PICKER_FORMAT);

    return (
      <form action="/actions/exercise/copy-day" method="POST" data-noreset>
        <input type="hidden" name="type" value="export" />
        <input type="hidden" name="from" value={activeDay.toJSON()} />

        <Modal width="600px" className="Export-Workout">
          <div className="head">
            <h2 className="alt">Export Today's Workout</h2>
          </div>

          <div className="body">
            <div className="columns">
              <div className="column" data-col="1/1">
                <div className="label">Select a date:</div>
                <DateInput name="to" defaultValue={exportDate} />
              </div>
            </div>
          </div>

          <div className="foot">
            <div className="columns">
              <div className="column" data-col="1/2">
                <button className="button-input" type="submit">
                  Export
                </button>
              </div>

              <div className="column mobile-hidden" data-col="1/2">
                <a className="cancel" href="/actions/refresh?modal=">
                  Cancel
                </a>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

ExportWorkoutModal.contextTypes = { locals: PropTypes.object };

export default ExportWorkoutModal;
